
























































































































































































































import { defineComponent, ref } from '@vue/composition-api'
import { getRegions, getSubregions } from '~/api/Address/address'
import { getAgencies, getClients } from '~/api/Agency/agency.api'
import { getRemittanceReports } from '~/api/Remittances/remittances.api'
import { getUsers } from '~/api/Users/users.api'
import AppView from '~/components/AppView.vue'
import Autocomplete from '~/components/Autocomplete.vue'
import RangeDatePicker from '~/components/RangeDatePicker.vue'
import { Roles } from '~/plugins/permissions'
import { chipClasses } from '~/utils/chipClasses.constant'
import { DatePicker, Params } from '~/utils/interfaces'
import { DeliveryCurrenciesEnum } from '~/utils/interfaces/remittance.interface'

export default defineComponent({
  components: { AppView, Autocomplete, RangeDatePicker },
  setup() {
    const owner = ref(0)
    return {
      getRemittanceReports,
      getAgencies,
      getClients,
      owner,
      getRegion: (params?: Params) =>
        getRegions({ ...params, country__name: 'Cuba' }),
      getSubregion: (params?: Params) =>
        getSubregions({ ...params, country__name: 'Cuba' }),
      chipClasses,
      getMessengers: (params?: Params) =>
        getUsers({ ...params, services__name: 'REMITTANCE' }),
      getDeliveryMessengers: (params?: Params) =>
        getUsers({
          ...params,
          services__name: 'REMITTANCE',
          role: Roles.AGENT,
        }),
    }
  },
  data() {
    return {
      DeliveryCurrenciesEnum,
      headers: [
        { text: this.$t('agency_name'), value: 'name' },
        { text: this.$t('count'), value: 'count' },
      ],
      tags: [
        {
          value: 'AGENT',
          text: this.$t('yours'),
        },
        {
          value: 'AGENCY',
          text: this.$t('of-network'),
        },
      ],
    }
  },
  methods: {
    serializeFilter(filter: Params) {
      const dates = (this.$refs.datePicker as DatePicker).getData()
      const deliveryDates = (this.$refs.deliveryPicker as DatePicker).getData()
      const assignment = (this.$refs.assignmentPicker as DatePicker).getData()
      return {
        ...filter,
        created_at__gte: dates.minDate,
        created_at__lte: dates.maxDate,
        remittance__assignment_at__gte: assignment.minDate,
        remittance__assignment_at__lte: assignment.maxDate,
        remittance__delivered_at__gte: deliveryDates.minDate,
        remittance__delivered_at__lte: deliveryDates.maxDate,
        remittance__delivery_currency__in: (
          filter.remittance__delivery_currency__in || []
        ).join(','),
      } as { [key: string]: any }
    },
  },
})
